import React from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { HomeUpdatedArrowIcon } from "../../../../app-constants";

function Eventsprogram() {
  return (
    <section className="tekrevol__insights_landing overflow-x-hidden events_programs p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#000" }}>Events and Programs</h2>
            <p>
              An event is an organized occasion or gathering designed for a
              specific purpose. Events can vary widely in scope, scale, and
              intent.
            </p>
          </Col>
          {/* <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
              <Nav
                variant="pills"
                className=" blog-tabs  nav nav-tabs nav-justified"
                id="blog-tab"
              >
                <Nav.Item>
                  <Nav.Link eventKey="0">All Events</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="1">Upcoming Event</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="2">Past Events</Nav.Link>
                </Nav.Item>
              </Nav>
            </Col> */}
        </Row>

        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <Row>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-3 mb-md-4 mb-xl-0"
              >
                <div className="blog-item tekrevol_gray_bg">
                  <Link
                    href="https://www.tekrevol.com/blogs/abeer-raza-ignites-step-conference-2024-with-insights-on-budget-allocation-and-optimization-for-retail-brands/"
                    aria-label="Abeer Raza Ignites Step Conference 2024 with Insights on “Budget Allocation and Optimization for Retail Brands”"
                    className="img-link"
                  >
                    <StaticImage
                      src="../../../images/home-update/insights/events-1.webp"
                      alt="Abeer Raza Ignites Step Conference 2024 with Insights on “Budget Allocation and Optimization for Retail Brands”"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["auto"]}
                      width={509}
                      height={287}
                    />
                  </Link>
                  <div className="content">
                    <div className="inner-wrap">
                      <h2 className="title">
                        Abeer Raza Ignites Step Conference 2024 with Insights on
                        “Budget Allocation and Optimization for Retail Brands”
                      </h2>
                      <p>
                        In a riveting session at Step Conference 2024, Abeer
                        Raza, co-founder and CMO TekRevol, took center stage to
                        unravel the intricacies of “Budget Allocation and
                        Optimization for Retail Brands.” The event, renowned for
                        hosting thought leaders and visionaries, witnessed a…
                      </p>
                    </div>
                    <div className="bottom-wrap">
                      <span className="date">May 13, 2024</span>
                      <Link
                        href="https://www.tekrevol.com/blogs/abeer-raza-ignites-step-conference-2024-with-insights-on-budget-allocation-and-optimization-for-retail-brands/"
                        aria-label="Abeer Raza Ignites Step Conference 2024 with Insights on “Budget Allocation and Optimization for Retail Brands”"
                        className="box-link"
                      >
                        Learn More {HomeUpdatedArrowIcon}
                      </Link>
                    </div>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-3 mb-md-0"
              >
                <div className="blog-item tekrevol_gray_bg">
                  <Link
                    href="https://www.tekrevol.com/blogs/tekrevol-leadership-shines-at-tablons-investor-dinner-in-dubai/"
                    aria-label="TekRevol Leadership Shines at Tablon’s Investor Dinner in Dubai"
                    className="img-link"
                  >
                    <StaticImage
                      src="../../../images/home-update/insights/events-2.webp"
                      alt="TekRevol Leadership Shines at Tablon’s Investor Dinner in Dubai"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["auto"]}
                      width={509}
                      height={287}
                    />
                  </Link>
                  <div className="content">
                    <div className="inner-wrap">
                      <h2 className="title">
                        TekRevol Leadership Shines at Tablon’s Investor Dinner
                        in Dubai
                      </h2>
                      <p>
                        On the vibrant evening of December 14, 2023, the
                        powerhouse leadership trio of TekRevol—Asim Rais
                        Siddiqui, Abeer Raza, and Behzad Raza—graced Tablon’s
                        Investor Dinner in Dubai with their presence. The event
                        provided a unique platform for networking, fostering new
                        connections,…
                      </p>
                    </div>
                    <div className="bottom-wrap">
                      <span className="date">May 13, 2024</span>
                      <Link
                        href="https://www.tekrevol.com/blogs/tekrevol-leadership-shines-at-tablons-investor-dinner-in-dubai/"
                        aria-label="TekRevol Leadership Shines at Tablon’s Investor Dinner in Dubai"
                        className="box-link"
                      >
                        Learn More {HomeUpdatedArrowIcon}
                      </Link>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="">
                <div className="blog-item tekrevol_gray_bg">
                  <Link
                    href="https://www.tekrevol.com/blogs/abeer-razas-insightful-discussion-on-mena-affiliates-roadmap-to-prosperity-at-ifx-expo-dubai/"
                    aria-label="Abeer Raza’s Insightful Discussion on MENA Affiliates’ Roadmap to Prosperity at iFX EXPO Dubai"
                    className="img-link"
                  >
                    <StaticImage
                      src="../../../images/home-update/insights/events-3.webp"
                      alt="Abeer Raza’s Insightful Discussion on MENA Affiliates’ Roadmap to Prosperity at iFX EXPO Dubai"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["auto"]}
                      width={509}
                      height={287}
                    />
                  </Link>
                  <div className="content">
                    <div className="inner-wrap">
                      <h2 className="title">
                        Abeer Raza’s Insightful Discussion on MENA Affiliates’
                        Roadmap to Prosperity at iFX EXPO Dubai
                      </h2>
                      <p>
                        In a high-profile appearance at the iFX EXPO Dubai,
                        Abeer Raza, Co-Founder and Chief Marketing Officer of
                        TekRevol, took the stage alongside other industry
                        luminaries to discuss the ‘Roadmap to Prosperity: MENA
                        Affiliates in 2024.’ The event, held on Thursday,…
                      </p>
                    </div>
                    <div className="bottom-wrap">
                      <span className="date">February 7, 2024</span>
                      <Link
                        href="https://www.tekrevol.com/blogs/abeer-razas-insightful-discussion-on-mena-affiliates-roadmap-to-prosperity-at-ifx-expo-dubai/"
                        aria-label="Abeer Raza’s Insightful Discussion on MENA Affiliates’ Roadmap to Prosperity at iFX EXPO Dubai"
                        className="box-link"
                      >
                        Learn More {HomeUpdatedArrowIcon}
                      </Link>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Eventsprogram;
